import * as Configuration from '../../../app.constants.js';

WhatsappVia360DRegisterController.$inject = ['$scope', 'TopToolbarFactory', '$stateParams', '$http', 'company', 'AlertingFactory', 'LoginFactory', '$state', 'AddAccountFactory'];
export function WhatsappVia360DRegisterController($scope, TopToolbarFactory, $stateParams, $http, company, AlertingFactory, LoginFactory, $state, AddAccountFactory) {
  $scope.submit = submit;
  init();

  function submit(formData) {
    let http_hook = null;
    if (!!$scope.existingAuthId) {
      http_hook = AddAccountFactory.reauthorize360DialogAccount(company.id, $scope.existingAuthId, formData);
    } else {
      http_hook = AddAccountFactory.register360DialogAccount(company.id, formData);
    }

    http_hook.then(function success(response) {
      LoginFactory.redirectWithJwtShort(response.data);
    }, function error(response) {
      AlertingFactory.alertHTTPError(response);
    });
  }

  function initAuthorizationData() {
    AddAccountFactory.get360DialogAuthorizationData(company.id, $scope.existingAuthId).then(function success(response) {
      $scope.formData.business_name = response.data.business_name;
      $scope.formData.phone_number = response.data.phone_number;
    }, function error(response) {
      AlertingFactory.alertHTTPError(response);
    });
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('add-account/whatsapp-via-360D/title', $scope);
    $scope.formData = {};
    if (!!$stateParams.authId) {
      $scope.existingAuthId = $stateParams.authId;
      initAuthorizationData();
    }
  }
}
